import { FC, PropsWithChildren, useCallback, useMemo, useState } from 'react'
import { ActiveVideoVisitContext } from '~/shared/hooks/activeVideoVisit'

export const ActiveVideoVisitProvider: FC<PropsWithChildren> = ({ children }) => {
  const [activeVideoVisitId, setActiveVideoVisitId] = useState<number | null>(null)
  const clearActiveVideoVisit = useCallback(() => setActiveVideoVisitId(null), [])

  const value = useMemo(
    () => ({ activeVideoVisitId, setActiveVideoVisitId, clearActiveVideoVisit }),
    [activeVideoVisitId, clearActiveVideoVisit],
  )

  return (
    <ActiveVideoVisitContext.Provider value={value}>{children}</ActiveVideoVisitContext.Provider>
  )
}
